import { lazy } from "react";

const BankerLogin = lazy(() => import("../Component/BankerForm/BankerLogin"));
const BankerDashboard = lazy(() => import("../Component/BankerForm/BankerDashboard"));
const BankerLoanApplicationList = lazy(() => import("../Component/BankerForm/BankerLoanApplicationList"));
const ThankYou = lazy(() => import("../Component/Banker/ThankYou"));
const ThankyouForUpdateBanker = lazy(() => import("../Component/Banker/ThankyouForUpdateBanker"));

// Banker pages authenticate with their own `banker_Token` localStorage key
// (checked inside BankerDashboard/BankerLoanApplicationList themselves), not
// the sales-side `login` flag that useAuthGuard/ProtectedRoute check — so
// none of these go through the shared ProtectedRoute gate.
const bankerRoutes = [
  { path: "/banker-login", element: <BankerLogin />, protected: false },
  { path: "/banker-dashboard", element: <BankerDashboard />, protected: false },
  { path: "/banker-loan-application", element: <BankerLoanApplicationList />, protected: false },
  { path: "/thankyou", element: <ThankYou />, protected: false },
  { path: "/thankyou-for-registration", element: <ThankyouForUpdateBanker />, protected: false },
];

export default bankerRoutes;
